import React from "react";
import { Row, Col } from "react-bootstrap";
import DataTable from "../../table/DataTable";

const Step3BulkConfirm = ({ selectedReceivers }) => {
  const columns = [
    { label: "Account name/Receiver", key: "name", render: (item) => <span className="fw-bold">{item.name}</span> },
    { label: "Country", key: "country", render: () => "Malaysia" },
    { label: "Bank/Agent", key: "bank", render: (item) => item.bank },
    { label: "Acc no/IBAN", key: "accNo", render: () => "0552000003601" },
    { label: "Receiving amount/Currency", key: "receivingAmount", render: () => "3.4225 MYR" },
    { label: "Send amount/Currency", key: "sendAmount", render: () => "1 SGD" },
    { label: "Fee/Currency", key: "fee", render: () => "0 SGD" },
  ];

  const summaryData = [
    { currency: "MYR", value: "6.845" },
    { currency: "PHP", value: "36.45" },
  ];

  return (
    <div className="mt-2">
      <div className="card shadow-none rounded-4 mb-4" style={{ backgroundColor: "#F9FAFB" }}>
        <DataTable
          columns={columns}
          data={selectedReceivers}
          showPagination={false}
          minWidth="100%"
        />
      </div>

      <div className="d-flex justify-content-end mt-4">
        <div className="card border-0 shadow-sm rounded-4" style={{ width: "350px" }}>
          <div className="card-body p-4">
            <div className="mb-4">
              <span className="text-muted fs-11 fw-bold text-uppercase">Receiving Amount</span>
              {summaryData.map((item, idx) => (
                <div key={idx} className="d-flex justify-content-between mt-2">
                  <span className="text-muted fs-13">{item.currency}</span>
                  <span className="fw-bold text-black fs-14">{item.value}</span>
                </div>
              ))}
            </div>
            
            <div className="border-top pt-3 mb-3">
              <div className="d-flex justify-content-between">
                <span className="text-muted fs-13">Send Amount</span>
                <span className="fw-bold text-black fs-14">3 SGD</span>
              </div>
              <div className="d-flex justify-content-between mt-2">
                <span className="text-muted fs-13">Service Charge</span>
                <span className="fw-bold text-black fs-14">6 SGD</span>
              </div>
            </div>

            <div className="border-top pt-3">
              <div className="d-flex justify-content-between align-items-center">
                <span className="text-muted fs-13 fw-bold">Total to Pay</span>
                <span className="text-primary fw-bold fs-16" style={{ color: "#002147" }}>9 SGD</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step3BulkConfirm;
